import { useState } from 'react';
import { useBundleStore } from '../hooks/bundle-store';
import { useShallow } from 'zustand/react/shallow';

export default function SunButton() {
  const [isActive, setIsActive] = useState(false);

  const { lightBox, setLightBox, itemsHaveBacklit } = useBundleStore(
    useShallow((state) => ({
      lightBox: state?.lightBox,
      setLightBox: state?.setLightBox,
      itemsHaveBacklit: state.itemsHaveBacklit,
    })),
  );

  const isBackLitOn = lightBox;

  const handleChangeBacklit = () => {
    const value = !lightBox;
    setLightBox(value);
    window.dispatchEvent(
      new CustomEvent('changeBacklit', {
        detail: {
          lightBox: value,
        },
      }),
    );
  };

  return (
    itemsHaveBacklit?.length > 0 && (
      <div
        onClick={handleChangeBacklit}
        style={{
          width: '34px',
          height: '34px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: isBackLitOn ? 'var(--secondary-color)' : 'white',
          borderRadius: '50%',
          border: isBackLitOn ? '2px solid ' + 'var(--primary-color)' : '2px solid white',
          color: 'black',
          cursor: 'pointer',
          fontSize: '12px',
          padding: '5px',
          boxShadow: isActive ? '0 0 5px rgba(0, 0, 0, 0.15)' : 'none',
          transition: 'all 0.2s ease-in-out',
        }}
        onMouseDown={() => setIsActive(true)}
        onMouseUp={() => setIsActive(false)}
        onMouseLeave={() => setIsActive(false)}>
        <svg
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M15.5 9.99999C15.5 12.7614 13.2615 15 10.5 15C7.73862 15 5.50004 12.7614 5.50004 9.99999C5.50004 7.23857 7.73862 4.99999 10.5 4.99999C13.2615 4.99999 15.5 7.23857 15.5 9.99999Z"
            fill="white"
          />
          <path
            d="M11.25 0.833328C11.25 0.419115 10.9143 0.0833282 10.5 0.0833282C10.0858 0.0833282 9.75004 0.419115 9.75004 0.833328H11.25ZM9.75004 2.49999C9.75004 2.91421 10.0858 3.24999 10.5 3.24999C10.9143 3.24999 11.25 2.91421 11.25 2.49999H9.75004ZM11.25 17.5C11.25 17.0858 10.9143 16.75 10.5 16.75C10.0858 16.75 9.75004 17.0858 9.75004 17.5H11.25ZM9.75004 19.1667C9.75004 19.5809 10.0858 19.9167 10.5 19.9167C10.9143 19.9167 11.25 19.5809 11.25 19.1667H9.75004ZM19.6667 10.75C20.0809 10.75 20.4167 10.4142 20.4167 9.99999C20.4167 9.58578 20.0809 9.24999 19.6667 9.24999V10.75ZM18 9.24999C17.5858 9.24999 17.25 9.58578 17.25 9.99999C17.25 10.4142 17.5858 10.75 18 10.75V9.24999ZM3.00004 10.75C3.41425 10.75 3.75004 10.4142 3.75004 9.99999C3.75004 9.58578 3.41425 9.24999 3.00004 9.24999V10.75ZM1.33337 9.24999C0.91916 9.24999 0.583374 9.58578 0.583374 9.99999C0.583374 10.4142 0.91916 10.75 1.33337 10.75V9.24999ZM17.5122 4.04851C17.8051 3.75562 17.8051 3.28075 17.5122 2.98785C17.2193 2.69496 16.7444 2.69496 16.4515 2.98785L17.5122 4.04851ZM15.273 4.16636C14.9801 4.45926 14.9801 4.93413 15.273 5.22702C15.5659 5.51992 16.0408 5.51992 16.3337 5.22702L15.273 4.16636ZM5.72707 15.8336C6.01996 15.5407 6.01996 15.0659 5.72707 14.773C5.43418 14.4801 4.9593 14.4801 4.66641 14.773L5.72707 15.8336ZM3.4879 15.9515C3.19501 16.2444 3.19501 16.7192 3.4879 17.0121C3.78079 17.305 4.25567 17.305 4.54856 17.0121L3.4879 15.9515ZM16.4515 17.0121C16.7444 17.305 17.2193 17.305 17.5122 17.0121C17.8051 16.7192 17.8051 16.2444 17.5122 15.9515L16.4515 17.0121ZM16.3337 14.773C16.0408 14.4801 15.5659 14.4801 15.273 14.773C14.9801 15.0659 14.9801 15.5407 15.273 15.8336L16.3337 14.773ZM4.66641 5.22702C4.9593 5.51992 5.43418 5.51992 5.72707 5.22702C6.01996 4.93413 6.01996 4.45926 5.72707 4.16636L4.66641 5.22702ZM4.54856 2.98785C4.25567 2.69496 3.78079 2.69496 3.4879 2.98785C3.19501 3.28075 3.19501 3.75562 3.4879 4.04851L4.54856 2.98785ZM14.75 9.99999C14.75 12.3472 12.8472 14.25 10.5 14.25V15.75C13.6757 15.75 16.25 13.1756 16.25 9.99999H14.75ZM10.5 14.25C8.15283 14.25 6.25004 12.3472 6.25004 9.99999H4.75004C4.75004 13.1756 7.3244 15.75 10.5 15.75V14.25ZM6.25004 9.99999C6.25004 7.65278 8.15283 5.74999 10.5 5.74999V4.24999C7.3244 4.24999 4.75004 6.82436 4.75004 9.99999H6.25004ZM10.5 5.74999C12.8472 5.74999 14.75 7.65278 14.75 9.99999H16.25C16.25 6.82436 13.6757 4.24999 10.5 4.24999V5.74999ZM9.75004 0.833328V2.49999H11.25V0.833328H9.75004ZM9.75004 17.5V19.1667H11.25V17.5H9.75004ZM19.6667 9.24999H18V10.75H19.6667V9.24999ZM3.00004 9.24999H1.33337V10.75H3.00004V9.24999ZM16.4515 2.98785L15.273 4.16636L16.3337 5.22702L17.5122 4.04851L16.4515 2.98785ZM4.66641 14.773L3.4879 15.9515L4.54856 17.0121L5.72707 15.8336L4.66641 14.773ZM17.5122 15.9515L16.3337 14.773L15.273 15.8336L16.4515 17.0121L17.5122 15.9515ZM5.72707 4.16636L4.54856 2.98785L3.4879 4.04851L4.66641 5.22702L5.72707 4.16636Z"
            fill="var(--primary-color)"
          />
        </svg>
      </div>
    )
  );
}
